var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    on: {
      "input": _vm.update
    },
    model: {
      value: _vm.form.stage,
      callback: function ($$v) {
        _vm.$set(_vm.form, "stage", $$v);
      },
      expression: "form.stage"
    }
  }, 'v-select', Object.assign({}, _vm.attrs_input, {
    items: _vm.items,
    loading: _vm.loading
  }), false));

}
var staticRenderFns = []

export { render, staticRenderFns }